import "../css/Upload_20260403.css";
import axios from "axios";
import backendUrl from "../Utils/backendUrl";
import getAuthConfig from "../functions/getAuthConfig";
import { useOutletContext } from "react-router-dom";
import { useEffect, useState, useRef } from "react";

export default function Upload() {
  const { userData } = useOutletContext();
  const { userid,location_code } = userData;



  const [files, setFiles] = useState([]);
  const [uploadStatus, setUploadStatus] = useState(0); // 0 = allow, 1 = block
  const [loading, setLoading] = useState(false);

  const fileRef = useRef(null);

  // Handle file change
  const handleChange = (e) => {
    const selected = Array.from(e.target.files);

    //  Max 50 files check
    if (selected.length > 50) {
      alert("You can upload maximum 50 files only");
      return;
    }

    // ✅ Total size check (1MB = 1024 * 1024)
    const totalSize = selected.reduce((sum, file) => sum + file.size, 0);

    if (totalSize > 1024 * 1024) {
      alert("Total file size must be less than 1MB");
      return;
    }

    setFiles(selected);
  };

  // Upload
  const handleUpload = async () => {
    if (files.length === 0) {
      alert("Please select file");
      return;
    }
    setLoading(true);

    const formData = new FormData();
    files.forEach((file) => formData.append("files", file));
    formData.append("userid", userid);
    formData.append("location_code", location_code);

    try {
      const response = await axios.post(`${backendUrl}excelupload`, formData,getAuthConfig());

      console.log(response);

      alert(
        `Upload in progress...
      Total Files: ${response.data["total files"]}
      Total Rows: ${response.data["Total Entry"] || 0}
      Unmatched Stations: ${
        response.data.message.unmatchedStations?.join(", ") || "None"
      }
      Processing is running in background.`,
      );

      handleReset();
      getUploadStatus();
    } catch (error) {
      alert(error?.response?.data?.error || "Upload failed");
    } finally {
      setLoading(false);
      // setFiles([]);
    }
  };

  // Reset
  const handleReset = () => {
    setFiles([]);
    if (fileRef.current) fileRef.current.value = "";
  };

  const getUploadStatus = async () => {
    try {
      const res = await axios.get(
        `${backendUrl}getexcelUploadStatus/${userid}`,
      );
      setUploadStatus(res.data.uploadStatus);
      if (res.data.uploadStatus) {
        setLoading(true);
      }
      else if(!res.data.uploadStatus){
      setLoading(false);
      }

    } catch {
      console.log("Status fetch error");
    }
  };

  useEffect(() => {
    document.title = "CopSuvidha/UploadFiles";
    getUploadStatus(); // initial call

    const interval = setInterval(() => {
      // console.log('you called every 5sec ');
      getUploadStatus();
    }, 5000);

    return () => clearInterval(interval);
  }, [userid]);

  return (
    <div className="d-flex mt-5 justify-content-center  align-items-center">
      <div
        className="card shadow-lg p-4"
        style={{ width: "500px", borderRadius: "20px" }}
      >
        {/* Title */}
        <h3 className="text-center text-primary mb-4 fw-bold">
          E-Sakshya File Upload
        </h3>

        {/* File Input */}
        <div className="mb-3">
          <label className="form-label fw-semibold">Select Excel File</label>

          <input
            ref={fileRef}
            type="file"
            className="form-control"
            multiple
            accept=".xls,.xlsx"
            onChange={handleChange}
            disabled={uploadStatus === 1}
          />

          <div className="form-text">Max size: 1MB</div>
        </div>

        {/* File Preview */}
        {files.length > 0 && (
          <div className="alert alert-secondary py-2">
            <div>
              Total Files Selected: <strong>{files.length}</strong>
            </div>
          </div>
        )}

        {/* Status */}
        {uploadStatus === 1 ? (
          <div className="alert alert-danger text-center">
            Upload locked. Please wait...
          </div>
        ) : (
          <div className="alert alert-success text-center">
            You can upload file
          </div>
        )}

        {/* Buttons */}
        <div className="d-flex gap-2 mt-3">
          <button
            className="btn btn-primary w-50"
            onClick={handleUpload}
            disabled={uploadStatus === 1 || files.length === 0 || loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2"></span>
                Uploading...
              </>
            ) : (
              "Upload File"
            )}
          </button>

          <button className="btn btn-warning w-50" onClick={handleReset}>
            Reset
          </button>
        </div>
      </div>
    </div>
  );
}
